import React from 'react';

import { StyledButtonGroup } from './forms.styled';
import { ButtonGroupFormType } from './forms.types';

export const ButtonGroupForm = ({ form }: { form: ButtonGroupFormType }): React.ReactElement => (
  <StyledButtonGroup
    value={form.value}
    disabled={form.disabled}
    id={form.id}
    options={form.options}
    onClick={form.onChange.bind(form)}
  />
);
